export default "__VITE_ASSET__DLoLt07T__"